import { Stack, useTheme } from '@mui/material';
import { Box } from '@mui/system';

import { Spacer } from 'theSource/components/Spacer';

export interface SectionProps {
  name: string;
  children: JSX.Element | JSX.Element[];
  testId?: string;
  spacerHeight?: number;
}

export const Section = ({
  name,
  children,
  testId = 'section',
  spacerHeight = 4,
}: SectionProps) => {
  const theme = useTheme();
  return (
    <Box data-testid={testId}>
      <h2 className="headline-3">{name}</h2>
      <Spacer height={spacerHeight} />
      <Stack spacing={theme.spacing(4)}>{children}</Stack>
    </Box>
  );
};
